"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassthroughConditionService = exports.ConditionService = void 0;
var lodash_1 = require("lodash");
var condition_1 = require("./condition");
var matcher_1 = require("./matcher");
var array_utils_1 = require("../util/array-utils");
var properties_maker_1 = require("../util/properties-maker");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var answer_condition_context_1 = require("../logic/answer-condition-context");
var ConditionService = /** @class */ (function () {
    function ConditionService() {
    }
    ConditionService.prototype.evalForEqual = function (condition, valueToCheck) {
        var _this = this;
        // if we receive multiple answers, its okay if we match with at least one of them
        // for this condition to be true
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) { return _this.evalForEqual(condition, value); });
        }
        if ((0, lodash_1.isObject)(valueToCheck)) {
            return (0, lodash_1.isEqual)(valueToCheck, condition.value);
        }
        return valueToCheck === condition.value;
    };
    ConditionService.prototype.evalForNotEqual = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return !valueToCheck.some(function (value) { return _this.evalForEqual(condition, value); });
        }
        if ((0, lodash_1.isObject)(valueToCheck)) {
            return !(0, lodash_1.isEqual)(valueToCheck, condition.value);
        }
        return valueToCheck !== condition.value;
    };
    ConditionService.prototype.evalForIn = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) { return _this.evalForIn(condition, value); });
        }
        return condition.value.includes(valueToCheck);
    };
    ConditionService.prototype.evalForNotIn = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) { return _this.evalForNotIn(condition, value); });
        }
        return !condition.value.includes(valueToCheck);
    };
    ConditionService.prototype.evalForContains = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForContains(condition, value);
            });
        }
        if ((0, lodash_1.isString)(condition.value) && !condition.value.trim()) {
            return false;
        }
        try {
            return valueToCheck.toLowerCase().includes(condition.value.toLowerCase());
        }
        catch (e) {
            return valueToCheck.includes(condition.value);
        }
    };
    ConditionService.prototype.evalForNotContains = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForNotContains(condition, value);
            });
        }
        if ((0, lodash_1.isString)(condition.value) && !condition.value.trim()) {
            return false;
        }
        try {
            return !valueToCheck
                .toLowerCase()
                .includes(condition.value.toLowerCase());
        }
        catch (e) {
            return !valueToCheck.includes(condition.value);
        }
    };
    ConditionService.prototype.evalForGreaterThan = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForGreaterThan(condition, value);
            });
        }
        // handle bipolar matrix case where the
        // condition is of the format {row, number}
        // and the knowledge base value to check is {row, column, number}
        if (valueToCheck instanceof Object) {
            return this.evalForGreaterThan(__assign(__assign({}, condition), { value: condition.value.number }), valueToCheck.number);
        }
        return valueToCheck > condition.value;
    };
    ConditionService.prototype.evalForLowerThan = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForLowerThan(condition, value);
            });
        }
        // handle bipolar matrix case where the
        // condition is of the format {row, number}
        // and the knowledge base value to check is {row, column, number}
        if (valueToCheck instanceof Object) {
            return this.evalForLowerThan(__assign(__assign({}, condition), { value: condition.value.number }), valueToCheck.number);
        }
        return valueToCheck < condition.value;
    };
    ConditionService.prototype.evalForGreaterThanEqual = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForGreaterThanEqual(condition, value);
            });
        }
        // handle bipolar matrix and numeric open ended case where the
        // condition is of the format {row, number}
        // and the knowledge base value to check is {row, column, number}
        if (valueToCheck instanceof Object && (0, lodash_1.has)(valueToCheck, 'number')) {
            return this.evalForGreaterThanEqual(__assign(__assign({}, condition), { value: condition.value.number }), valueToCheck.number);
        }
        return valueToCheck >= condition.value;
    };
    ConditionService.prototype.evalForLowerThanEqual = function (condition, valueToCheck) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForLowerThanEqual(condition, value);
            });
        }
        // handle bipolar matrix case where the
        // condition is of the format {row, number}
        // and the knowledge base value to check is {row, column, number}
        if (valueToCheck instanceof Object) {
            return this.evalForLowerThanEqual(__assign(__assign({}, condition), { value: condition.value.number }), valueToCheck.number);
        }
        return valueToCheck <= condition.value;
    };
    ConditionService.prototype.evalForContainsWord = function (condition, valueToCheck, denominator) {
        var _this = this;
        if (valueToCheck instanceof Array) {
            return valueToCheck.some(function (value) {
                return _this.evalForContainsWord(condition, value);
            });
        }
        var stringValue = valueToCheck.toString();
        var transformedDenominator = denominator ? denominator : answer_condition_context_1.WhiteSpaceRegex;
        var words = stringValue.trim().split(transformedDenominator, undefined);
        return words.includes(condition.value);
    };
    ConditionService.prototype.evalForIsNull = function (condition, valueToCheck) {
        return valueToCheck.length === 0;
    };
    ConditionService.prototype.evalForIsNotNull = function (condition, valueToCheck) {
        return valueToCheck.length !== 0;
    };
    ConditionService.prototype.evalForIncludes = function (condition, valueToCheck) {
        return valueToCheck.includes(condition.value);
    };
    ConditionService.prototype.evalForNotIncludes = function (condition, valueToCheck) {
        return !valueToCheck.includes(condition.value);
    };
    ConditionService.prototype.evalForIncludesOnly = function (condition, valueToCheck) {
        if (valueToCheck.length !== 1) {
            return false;
        }
        return valueToCheck.includes(condition.value);
    };
    ConditionService.prototype.evalForAll = function (condition, valueToCheck) {
        console.warn('[Warn]: ValueToCheck is not used here', valueToCheck);
        return array_utils_1.ArrayUtils.every(condition.value, function (value) {
            return condition.value.includes(value);
        });
    };
    ConditionService.prototype.evalFor = function (op) {
        throw new advanced_logic_error_1.AdvancedLogicError("Not implemented for operator: ".concat(op));
    };
    ConditionService.prototype.eval = function (condition, knowledge) {
        var valueToCheck = this.extractValueFromKnowledge(knowledge, condition);
        if (!valueToCheck) {
            return false;
        }
        var result = false;
        var op = condition.matcher;
        var valueType = (0, lodash_1.get)(condition, 'context.valueType', '');
        var isMatrix = valueType === 'matrix';
        var isBipolarMatrix = valueType === 'matrixBipolar';
        var isNumericOpenEndedMatrix = valueType === 'matrixNumericOpenEnded';
        if (isMatrix) {
            // IMPORTANT: For "not_equals" evaluations and matrix type answers, we need to verify that we don't
            //      try to evaluate against all rows.
            //      ie: a respondent answers [{ row: 1, column: 1}, {row: 2, column: 2}]
            //      adding a rule that checks that row 1 is not column 2, would also check
            //      that ROW 2 is not column 2... which is wrong and filtering row 2 from the list fixes the issue
            valueToCheck = valueToCheck.filter(function (value) { return value.row === condition.value.row; });
        }
        if (isBipolarMatrix) {
            // IMPORTANT: For "not_equals" evaluations and matrix type answers, we need to verify that we don't
            //      try to evaluate against all rows.
            //      ie: a respondent answers [{ row: 1, column: 1}, {row: 2, column: 2}]
            //      adding a rule that checks that row 1 is not column 2, would also check
            //      that ROW 2 is not column 2... which is wrong and filtering row 2 from the list fixes the issue
            valueToCheck = valueToCheck
                .filter(function (value) { return value.row === condition.value.row; })
                .map(function (_a) {
                var row = _a.row, value = _a.value;
                return ({
                    row: row,
                    number: value,
                });
            });
        }
        if (isNumericOpenEndedMatrix) {
            valueToCheck = valueToCheck
                .filter(function (value) {
                return value.row === condition.value.row &&
                    value.column === condition.value.column;
            })
                .map(function (_a) {
                var row = _a.row, column = _a.column, value = _a.value;
                return ({
                    row: row,
                    column: column,
                    number: value,
                });
            });
        }
        if (op === matcher_1.Matcher.Equal) {
            result = this.evalForEqual(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.NotEqual) {
            result = this.evalForNotEqual(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.In) {
            result = this.evalForIn(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.NotIn) {
            result = this.evalForNotIn(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.Contains) {
            result = this.evalForContains(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.NotContains) {
            result = this.evalForNotContains(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.GreaterThan) {
            result = this.evalForGreaterThan(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.LowerThan) {
            result = this.evalForLowerThan(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.GreaterThanEqual) {
            result = this.evalForGreaterThanEqual(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.LowerThanEqual) {
            result = this.evalForLowerThanEqual(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.ContainsWord) {
            result = this.evalForContainsWord(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.IsNull) {
            result = this.evalForIsNull(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.IsNotNull) {
            result = this.evalForIsNotNull(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.Includes) {
            result = this.evalForIncludes(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.IncludesOnly) {
            result = this.evalForIncludesOnly(condition, valueToCheck);
        }
        else if (op === matcher_1.Matcher.NotIncludes) {
            result = this.evalForNotIncludes(condition, valueToCheck);
        }
        else {
            result = this.evalFor(op);
        }
        return result;
    };
    // private evalDeep(condition: ICondition, knowledge: any): boolean {
    //   var result = false;
    //   let op = condition.operator;
    //   if (op === Operator.All) {
    //     // Operator.All
    //     result = ArrayUtils.every(condition.conditions, (cond: ICondition) =>
    //       this.eval(cond, knowledge),
    //     );
    //   } else {
    //     // Operator.Any
    //     result = ArrayUtils.some(condition.conditions, (cond: ICondition) =>
    //       this.eval(cond, knowledge),
    //     );
    //   }
    //   return result;
    // }
    // eval(condition: ICondition, knowledge: any): boolean {
    //   if (ArrayUtils.isEmpty(condition.conditions)) {
    //     return this.evalShallow(condition, knowledge);
    //   }
    //   return this.evalDeep(condition, knowledge);
    // }
    // isLeafCondition(condition: ICondition): boolean {
    //   return !condition.conditions && condition.value !== undefined;
    // }
    // isNodeCondition(condition: ICondition): boolean {
    //   return !this.isLeafCondition(condition);
    // }
    // createAndCondition(conditions: ICondition[], id?: string): ICondition {
    //   return new Condition({
    //     id: id,
    //     conditions: conditions,
    //     operator: Operator.All,
    //   });
    // }
    // createOrCondition(conditions: ICondition[], id?: string): ICondition {
    //   return new Condition({
    //     id: id,
    //     conditions: conditions,
    //     operator: Operator.Any,
    //   });
    // }
    // addCondition(condition: ICondition, newCondition: ICondition): ICondition {
    //   let updatedConditions;
    //   if (condition.conditions) {
    //     updatedConditions = [...condition.conditions, newCondition];
    //   } else {
    //     updatedConditions = [newCondition];
    //   }
    //   return Condition.buildFrom(condition, { conditions: updatedConditions });
    // }
    // removeCondition(condition: ICondition, id: string): ICondition {
    //   return Condition.buildFrom(condition, {
    //     conditions: ArrayUtils.removeBy(
    //       <ICondition[]>condition.conditions,
    //       'id',
    //       id,
    //     ),
    //   });
    // }
    ConditionService.buildFrom = function (src, props) {
        return new condition_1.Condition(properties_maker_1.PropertiesMaker.merge(src, props));
    };
    return ConditionService;
}());
exports.ConditionService = ConditionService;
var PassthroughConditionService = /** @class */ (function (_super) {
    __extends(PassthroughConditionService, _super);
    function PassthroughConditionService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PassthroughConditionService.prototype.extractValueFromKnowledge = function (knowledge) {
        return knowledge;
    };
    return PassthroughConditionService;
}(ConditionService));
exports.PassthroughConditionService = PassthroughConditionService;
